export default __webpack_public_path__ + "static/media/Vectordocument.e1950d17.svg";